// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
// import { connect } from "react-redux"; // Starter Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductListSortSelectStyles } from "@store/Overrides/Widgets/ProductList/ProductListSortSelect";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import setIsFilterNavOpen from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/Handlers/setIsFilterNavOpen";
import { connect, ResolveThunks } from "react-redux";

const ProductCount = getWidgetComponent("ProductList/ProductListProductCount");
const SortSelect = getWidgetComponent("ProductList/ProductListSortSelect");

const mapDispatchToProps = {
    setIsFilterNavOpen,
};
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = ReturnType<typeof mapStateToProps> & WidgetProps & ResolveThunks<typeof mapDispatchToProps>; // Starter Custom Code

export interface ProductListControlsContainerStyles {
    container?: GridContainerProps;
    countGridItem?: GridItemProps;
    countTableViewGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    filterGridItem?: GridItemProps;
    filterTableViewGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    viewSelectTableViewGridItem?: GridItemProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    controlsWrapper?: InjectableCss;
    sort?: ProductListSortSelectStyles;
    filterButton?: ButtonPresentationProps;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {
    wrapper: mergeProps<ProductListControlsContainerStyles["wrapper"]>(resultCountProps.wrapper, {
        css: css`
            align-items: center;
            margin-bottom: ${pxToRem(18)};
        `,
    }),
    controlsWrapper: {
        css: css`
            display: flex;
            align-items: center;

            > div {
                ${inlineSeparatorStyles({ spacing: "2em", spacingType: "padding", side: "left", height: "20px" })}
            }
        `,
    },
    filterButton: {
        variant: "tertiary",
        css: css`
            ${x => x.theme.button.tertiary.css}
            width: 100%;
            margin-bottom: ${pxToRem(18)};

            ${breakpoint("md")} {
                display: none;
            }
        `,
    },
    sort: {
        wrapper: {
            css: css`
                display: none;

                ${breakpoint("md")} {
                    display: block;
                }
            `,
        },
        select: {
            labelProps: {
                css: css`
                    white-space: nowrap;
                `,
            },
        },
    },
};

const styles = controlsContainerStyles;

const ProductListControlsContainer: FC<Props> = ({
    id,
    view,
    // Starter Custom Code
    setIsFilterNavOpen,
}) => {
    /* Starter Custom Code - Start */
    const showViewZone = useZoneIsActive(id, "View");

    const openDrawer = () => {
        setIsFilterNavOpen({ isOpen: true });
    };

    return (
        <>
            <Button onClick={openDrawer} {...styles.filterButton}>
                {translate("Sort & Filter")}
            </Button>
            <StyledWrapper {...styles.wrapper}>
                <ProductCount />
                <StyledWrapper {...styles.controlsWrapper}>
                    {showViewZone && <Zone contentId={id} zoneName="View" />}
                    <SortSelect
                        fields={{}}
                        uid="productListSortSelectDesktop"
                        label={translate("{0}:", translate("Sort by"))}
                        extendedStyles={styles.sort}
                        inline
                    />
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
    /* Starter Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListControlsContainer), // Starter Custom Code
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
